import styled from 'styled-components';

/** Height of the Input label row (20px) and of its bottom margin (8px), above the text field. */
const INPUT_LABEL_HEIGHT = '28px';

export const Container = styled.div`
  padding: 24px;

  flex: 1;

  background-color: ${(props) => props.theme.colors.greys.lightest};
  border-radius: 16px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
`;

export const ContainerHeader = styled.div`
  width: 100%;
`;

export const ContainerContent = styled.div`
  input {
    max-width: 50%;
  }

  & > form > div {
    margin-bottom: 24px;
  }
`;

export const PasswordFieldsContainer = styled.div`
  display: flex;
  gap: 24px;
`;

export const PasswordInputsContainer = styled.div`
  width: 50%;

  display: flex;
  flex-direction: column;
  gap: 20px;

  /* The fixed 64px Input height is 4px shorter than its label and field, the column must end with the last field. */
  & > div {
    height: auto;
  }

  /* This column already takes the 50% width that ContainerContent gives to inputs. */
  input {
    max-width: 100%;
  }
`;

/** Spans from the top of the first text field to the bottom of the last one. */
export const PasswordRulesContainer = styled.div`
  display: flex;
  margin-top: ${INPUT_LABEL_HEIGHT};
`;

export const TitleHeader = styled.div`
  color: ${(props) => props.theme.colors.greys.darkest};
  font: normal 700 16px/24px inter;

  margin-bottom: 10px;
`;

export const SubtitleHeader = styled.div`
  color: ${(props) => props.theme.colors.greys.dark};
  font: ${(props) => props.theme.fonts.textBig};
  margin: 12px 0px 12px 0px;
`;
